/**
 * Home2 Problem Section
 * Collapsible section explaining the website builder problem.
 * 
 * @module components/home2/Home2Problem
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronUp, XCircle } from 'lucide-react';
import { PROBLEM_CONTENT } from '../../data/home2Content';

const Home2Problem = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-full bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-all text-left"
          aria-expanded={expanded}
        >
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-1">
                {PROBLEM_CONTENT.title}
              </h2>
              <p className="text-sm text-slate-500">
                {PROBLEM_CONTENT.preview}
              </p>
            </div>
            {expanded ? (
              <ChevronUp className="h-6 w-6 text-slate-400 flex-shrink-0" />
            ) : (
              <ChevronDown className="h-6 w-6 text-slate-400 flex-shrink-0" />
            )}
          </div>
          
          {expanded && (
            <div className="mt-6 pt-6 border-t border-slate-100">
              <div className="space-y-3">
                {PROBLEM_CONTENT.points.map((point, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <XCircle className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
                    <div>
                      <span className="font-semibold text-slate-900">{point.platform}:</span>
                      <span className="text-slate-600 ml-1">{point.issue}</span>
                    </div>
                  </div>
                ))}
              </div>
              <p className="mt-6 text-sm text-slate-600 bg-slate-50 p-4 rounded-lg">
                {PROBLEM_CONTENT.conclusion}
              </p>
            </div>
          )}
        </button>
      </div>
    </section>
  );
};

export default Home2Problem;
